import React from 'react';
import { CheckIcon } from 'lucide-react';
import { MOCKUP_IMAGE, tomos } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
const features = ['6 sistemas clínicos listos para usar', 'Algoritmos visuales diseñados para consulta real', 'Protocolos que eliminan la duda', 'Herramientas prácticas aplicables desde hoy'];
export function SystemTomos() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-216" data-mp="xi0h0lmae3s0">
      <div className="mx-auto max-w-4xl" data-id="element-217" data-mp="xkmqwrwngvde">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-brandred" data-id="element-218" data-mp="sk8r1x57crqg">
          📦 El sistema completo
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-navy sm:text-4xl" data-id="element-219" data-mp="16kjkn7xwckfb">
          Sistema Maestro <span className="italic" data-id="element-220" data-mp="2hxuc5pck6581">Ruta Anticoagulación™</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy/65" data-id="element-221" data-mp="2dwsc56athp50">
          No es un manual. Es un sistema de decisión clínica diseñado para usarse en tiempo real.
        </p>

        <img src={MOCKUP_IMAGE} alt="Los 6 Tomos Maestros del sistema Ruta Anticoagulación" className="mx-auto mt-8 w-full max-w-xl" data-id="element-222" data-mp="27pqx0r4saju1" />

        <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-223" data-mp="2bphsh8599o4w">
          {tomos.map(t => <article key={t.num} className="rounded-3xl border border-navy/10 bg-white p-5 transition-shadow hover:shadow-[0_12px_40px_-24px_rgba(11,31,58,0.6)]" data-id="element-224" data-mp="2gpw2uwubxa63">
              <div className="flex items-center gap-3" data-id="element-225" data-mp="1nzxb2tor2yxq">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-navy text-lg" data-id="element-226" data-mp="1t01tip97y3ql">
                  <span aria-hidden data-id="element-227" data-mp="1xsl37b4sceq4">{t.emoji}</span>
                </span>
                <div data-id="element-228" data-mp="10d7bdyzvjgga">
                  <p className="text-[10px] font-black uppercase tracking-[0.2em] text-brandred" data-id="element-229" data-mp="10bnuc66e91dg">
                    Tomo {t.num}
                  </p>
                  <h3 className="font-display text-[17px] font-black leading-tight tracking-tight text-navy" data-id="element-230" data-mp="28m664k70zjo1">
                    {t.title}
                  </h3>
                </div>
              </div>
              <p className="mt-3 text-[14px] leading-snug text-navy/65" data-id="element-231" data-mp="2hehttyar8t0b">{t.text}</p>
            </article>)}
        </div>

        <div className="mt-8 rounded-3xl bg-navy p-6" data-id="element-232" data-mp="2de7evw4zis9b">
          <p className="text-center font-display text-xl font-black text-white" data-id="element-233" data-mp="1pnk5f6ff7ukn">
            📲 Acceso inmediato al sistema completo
          </p>
          <ul className="mx-auto mt-5 grid max-w-lg gap-2.5 sm:grid-cols-2" data-id="element-234" data-mp="1kpscc931i2ev">
            {features.map(f => <li key={f} className="flex items-start gap-2" data-id="element-235" data-mp="1yptahgrx6vqn">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandred-light" strokeWidth={3} data-id="element-236" data-mp="1tovw7fa16luf" />
                <span className="text-[13px] leading-snug text-white/85" data-id="element-237" data-mp="3a2m12o8z5e54">{f}</span>
              </li>)}
          </ul>
        </div>

        <TransformCTA text="Quiero los 6 Tomos Maestros ahora mismo" data-id="element-238" data-mp="3542c0ez33m8j" />
      </div>
    </section>;
}